import { i18n as bookingListItem } from "../components/BookingListItem";
import { i18n as bookingSearcherForm } from "../components/BookingSearcherForm";
import { i18n as paginationControls } from "../components/PaginationControls";

export default {
  en: { ...bookingListItem.en, ...bookingSearcherForm.en, ...paginationControls.en },
  es: { ...bookingListItem.es, ...bookingSearcherForm.es, ...paginationControls.es },
};
